import request from './request';
import deserialize from './deserialize';

export type Option = {
  optionNum: number;
  option: string;
};

export type Question = {
  id: string;
  question: string;
  questionType: string;
  required: boolean;
  status: string;
  orderNum: number;
  surveyID: string;
  options: {
    Options: Option[];
  };
};

export type Answer = {
  question: string;
  answer: string;
};

export type Survey = {
  id: string;
  createdAt: number;
  description: string;
  notification: string;
  status: string;
  terms: string;
  updatedAt: number;
  questions: Question[];
};

export function get(merchantId: string, surveyId: string) {
  return request<Survey>({
    url: `/api/v3/merchants/${merchantId}/survey/${surveyId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function createCompletedSurvey(
  rewardId: string,
  surveyId: string,
  companyId: string,
  answers: Answer[]
) {
  return request({
    url: `/api/v3/reward_cards/${rewardId}/survey/${surveyId}/complete`,
    method: 'POST',
    data: {
      data: {
        type: 'surveys',
        attributes: {
          companyID: companyId,
          answers,
        },
      },
    },
  });
}
